import { render, staticRenderFns } from "./case-label.vue?vue&type=template&id=6fb9a8d1&"
import script from "./case-label.vue?vue&type=script&lang=ts&"
export * from "./case-label.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports